import { PropsWithChildren, ReactElement, ReactNode } from "react";

import _ from "lodash";
import Head from "next/head";

import BaseGrid from "@/components/shared/BaseGrid";
import LearnMoreSidebar from "@/components/shared/LearnMoreSidebar";
import MenuSidebar from "@/components/shared/MenuSidebar";
import TerminalPanel from "@/components/TerminalPanel";
import { LayoutMode, layoutModes } from "@/constants/layoutModes";
import { LearnMoreEntryKey } from "@/constants/learnMore";
import { LeftDrawerProvider, RightDrawerProvider } from "@/providers/useDrawers";
import { wrapWith } from "@/utils/wrapWith";

const CommonLayoutProviders = wrapWith(LeftDrawerProvider, RightDrawerProvider);

export type CommonLayoutProps = {
  mode?: LayoutMode;
  learnMoreContent?: LearnMoreEntryKey[];
  LeftSidebar?: ReactNode;
  title?: string | null | undefined;
};

function CommonLayout({
  mode = layoutModes.default,
  learnMoreContent = mode.learnMoreContent,
  title,
  LeftSidebar,
  children,
}: PropsWithChildren<CommonLayoutProps>): ReactElement | null {
  const titleSuffix = mode.titleSuffix;
  if (title && titleSuffix) title = `${title} (${titleSuffix})`;

  return (
    <>
      <Head>
        <title>{_.compact(_.flatten([title, "Release"])).join(" | ")}</title>
        <meta key="metaDescription" content="Environments as a Service" name="description" />
        <link key="linkIcon" href="/favicon.ico" rel="icon" />
      </Head>
      <CommonLayoutProviders>
        <BaseGrid
          BottomPanel={<TerminalPanel />}
          LeftSidebar={<MenuSidebar>{LeftSidebar}</MenuSidebar>}
          RightSidebar={<LearnMoreSidebar entryKeys={learnMoreContent} />}
        >
          {children}
        </BaseGrid>
      </CommonLayoutProviders>
    </>
  );
}

export default CommonLayout;
